import { isEmpty, omitBy } from "lodash";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

interface UtmParams {
  utm_campaign?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_content?: string;
  utm_page?: string;
  utm_segment?: string;
  utm_blog?: string;
  others?: string;
  gt_session_id?: string;
}

const useUtmParams = (): UtmParams => {
  const router = useRouter();
  const { utm_source, utm_blog, ...rest } = router.query as Record<
    string,
    string | undefined
  >;
  const [sessionId, setSessionId] = useState<string | undefined>(undefined);

  const isBlog = router.asPath.includes("resources/b");
  const [cookies] = useCookies(["utm_source", "utm_blog"]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleTrackerInitialized = () => {
        try {
          const sessionId = localStorage.getItem("GT_session_id");
          if (sessionId) setSessionId(sessionId);
        } catch (error) {
          console.error("Failed to get session ID from localStorage:", error);
        }
      };

      document.addEventListener(
        "data_tracker_initialized",
        handleTrackerInitialized
      );
      // Clean up event listener when component unmounts
      return () => {
        document.removeEventListener(
          "data_tracker_initialized",
          handleTrackerInitialized
        );
      };
    }
  }, []);

  const getUtmSource = (): string | undefined => {
    if (isBlog) {
      return cookies.utm_source || "blog";
    }
    return cookies.utm_source || utm_source || undefined;
  };

  const utmParams: UtmParams = {
    utm_source: getUtmSource(),
    utm_blog: isBlog ? cookies.utm_blog : utm_blog,
    gt_session_id: sessionId,
    // Extract only UTM parameters from rest
    ...Object.entries(rest)
      .filter(([key]) => key.startsWith("utm_"))
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {} as Record<string, any>),
  };

  return omitBy(utmParams, isEmpty);
};

export default useUtmParams;
